import { z } from "zod";

/**
 * One user-defined entry in a step's `dynamicInputs` config array (e.g.
 * `csv_transform_v4`'s extra formula/AI-context sockets). Persisted step
 * config is untrusted JSON (hand-edited via the event tester, legacy
 * shapes, etc.), so this is the single source of truth both the frontend
 * editor (`editorUtils.ts`) and the backend/canonical socket generator
 * (`dynamicInputSockets.ts`) parse against, rather than each hand-rolling
 * its own validation.
 *
 * `label`/`description` accept any value (not just strings) because an
 * invalid one doesn't invalidate the whole entry — callers fall back to a
 * computed default (e.g. a prettified `name`) when it isn't a non-empty
 * string, rather than dropping the entry.
 */
export const dynamicInputConfigEntrySchema = z.object({
  name: z
    .string()
    .refine(
      (name) => name.trim().length > 0,
      "name must not be empty or whitespace-only",
    ),
  label: z.unknown().optional(),
  description: z.unknown().optional(),
});

export type DynamicInputConfigEntry = z.infer<
  typeof dynamicInputConfigEntrySchema
>;
